import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function StatisticPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Statistic",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/statistics" />
    </Container>
  );
}

export default StatisticPage;